import { Message } from "./";

export default class TelFortuneMessage extends Message {
  constructor(data?: Partial<TelFortuneMessage>) {
    super(data);
  }
}
